module.exports = __webpack_public_path__ + "static/media/sliders-h-square.750a29b0.svg";